import React from 'react';
import ReactDOM from 'react-dom';
import { hydrateRoot } from 'react-dom/client';
import { Globals, Grid, GridItem, StyleReset } from '@bwoty-web/ui-kit';

import MainContainer from '../shared/components/MainContainer';
import HotelsProvider from '../shared/context/Hotels';
import LocationProvider from '../shared/context/Location';
import InitialStateProvider from '../shared/context/InitialState';
import { updateAllSearchParams } from '../shared/utils/searchParams';

const initialState = window.__INITIAL_HOTELFINDER_STATE__;
if (initialState) {
  updateAllSearchParams(initialState.location.query);

  const { isStandalone, utils, baseUrl } = initialState;
  const { siteId } = utils;

  const hotelFinderRoot = document.getElementById('hotelfinder');

  // Check for page ID in HTML comments to determine if it is a new grid
  let isNewGrid = false;
  const pageIdNode = Array.from(document.childNodes).find(
    (item) => item?.nodeType === 8 && item?.data?.includes('pId:'),
  );
  if (pageIdNode) {
    const pageId = pageIdNode.data.replace('pId:', '').trim();
    isNewGrid = pageId.includes('-');
  }

  if ((isNewGrid || isStandalone) && hotelFinderRoot) {
    hydrateRoot(
      hotelFinderRoot,
      <InitialStateProvider initialState={initialState}>
        <LocationProvider>
          <HotelsProvider>
            <Globals siteId={siteId} baseUrl={baseUrl}>
              {isStandalone ? (
                <Grid root>
                  <GridItem columnSpan={12}>
                    <StyleReset />
                    <MainContainer />
                  </GridItem>
                </Grid>
              ) : (
                <MainContainer />
              )}
            </Globals>
          </HotelsProvider>
        </LocationProvider>
      </InitialStateProvider>,
    );
  } else {
    ReactDOM.hydrate(
      <InitialStateProvider initialState={initialState}>
        <LocationProvider>
          <HotelsProvider>
            <Globals siteId={siteId} baseUrl={baseUrl}>
              {isStandalone && <StyleReset />}
              <MainContainer />
            </Globals>
          </HotelsProvider>
        </LocationProvider>
      </InitialStateProvider>,
      hotelFinderRoot,
    );
  }
}

if (process.env.NODE_ENV !== 'production') {
  window.React = React; // enable debugger
}
